import { CommonModule } from '@angular/common';
import {
	Component,
	input,
	InputSignal,
	OnInit,
} from '@angular/core';

import { ShowcaseElement } from '../../../../products/products-create-page/products-showcase/products-showcase.entites';
import { ShowcaseElementComponent } from '../../../../products/products-create-page/showcase-element/showcase-element.component';

@Component({
	selector: 'app-mini-showcase',
	templateUrl: './mini-showcase.component.html',
	styleUrls: ['./mini-showcase.component.less'],
	imports: [
		ShowcaseElementComponent,
		CommonModule,
	],
})
export class MiniShowcaseComponent implements OnInit {

	public elements: InputSignal<Array<ShowcaseElement> | undefined> = input<Array<ShowcaseElement> | undefined>(undefined);

	constructor() { }

	public ngOnInit() {
	}

}
